import React from 'react';
//import {authRoles} from '../../auth';

export const EquivalenciasUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/equivalencias-details/:id',
        component: React.lazy(() =>
            import ('./EquivalenciasUpdate'))
    }]
};